<template>
  <nav class="level app-levelbar"
       style="padding: 4px;">
    <div class="level-left">
      <div class="level-item">
        <span class="level-title is-5">
          <strong>{{ menu.name }}</strong>
        </span>
      </div>
      <div style="white-space: pre-line">{{ menu.desc }}</div>
    </div>
  </nav>

</template>

<script>
  export default {
    props: {
      menu: {
        type: Object,
        required: true
      }
    },
    methods: {
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  .level-left
    display block
    width 100%

  .level-item
    justify-content flex-start

  .link-item
    color: #ff5722
    cursor: pointer

  .lp-title
    display flex
    justify-content space-between
    margin-bottom 16px

  .lp-page-title
    font-size 1.2rem

  .breadcrumb
    --separator "\2044"
    list-style none
    -ms-flex-align center
    align-items center
    display -ms-flexbox
    display flex
    -ms-flex-pack end
    justify-content flex-end

  .breadcrumb > li + li:before
    padding 0 5px
    color #ccc
    content var(--separator, "\2044")

  li
    display list-item
    text-align -webkit-match-parent

  .is-active
    color #393e46

  .level-title
    font-size 1.4rem

  .breadcrumb > .home
    color #ff5722

</style>
